import React, { useState, useEffect } from 'react';

import { generateKey } from 'Helpers/misc';

import Button from 'CommonComponents/Button';

export default function ApprovalSettingsApprover(props) {
    const [usersList, setUsersList] = useState(props.availableUsers);
    const [minValue, setMinValue] = useState(0);
    const [value, setValue] = useState(0);
    const [isFinalApprover, setIsFinalApprover] = useState(false);
    const [hasAddedApprover, setHasAddedApprover] = useState(false);

    useEffect(() => {
        calculateUsersList();
        calculateMinValue();
        setValue(props.approver?.value || '');
        checkIfFinalApprover();
    }, []);

    useEffect(() => {
        calculateUsersList();
        calculateMinValue();
        props.checkCanAddApprovers();
        checkIfFinalApprover();
    }, [props.approver.id]);

    const calculateUsersList = () => {
        if (props.approver.id) {
            const user = props.users.find((item) => item.id == props.approver.id);
            if (user) {
                setUsersList([...usersList, user]);
            }
        }
    };

    const calculateMinValue = () => {
        if (!props.prevApprover?.value) {
            setMinValue(0);
        } else {
            setMinValue(props.prevApprover.value + 1);
        }
    };

    const checkIfFinalApprover = () => {
        const approvers = props.users || []; // Ensure we have the list of all approvers
        const isLastApprover = approvers.length > 0 && props.index === approvers.length - 1;
        setIsFinalApprover(isLastApprover);
    };

    const changeValue = (e) => {
        if (!isFinalApprover) {
            const newValue = e.target.value ? parseInt(e.target.value) : '';
            setValue(newValue);

            // Add a new approver only if:
            // 1. The value was previously empty
            // 2. The user enters a new valid value
            // 3. No approver has been added yet
            if (!value && newValue && !hasAddedApprover && props.triggerCode === 'po') {
                props.addApprover();
                setHasAddedApprover(true); // Prevent further additions
            }
        }
    };

    const onBlurValue = () => {
        if (props.type === 'value' && !isFinalApprover) {
            const item = { ...props.approver };
            item.value = value;
            props.changeApprover(item, props.index);
        }
    };

    const changeApproverUser = (e) => {
        const userId = e.target.value ? parseInt(e.target.value) : null;
        props.changeApprover({ ...props.approver, id: userId }, props.index);
        props.calculateUsers();
    };

    const uid = generateKey();

    return (
        <div className="card front bg-white border-0 rounded-15px shadow my-4">
            <div className="card-body">
                <div className="form-row">
                    <div className="col-1">
                        <div className="pl-3">
                            <div className="tw-flex tw-flex-col tw-space-y-1.5">
                                <label className="tw-text-charcoal tw-text-sm tw-mb-0">{$t('Order')}</label>
                                <div className={'tw-flex tw-flex-row tw-items-center tw-pt-1'}>
                                    <h5>{props.index + 1}</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-4">
                        <div className="tw-flex tw-flex-col tw-space-y-1.5">
                            <label htmlFor={'approver-user-' + uid} className="tw-text-charcoal tw-text-sm tw-mb-0">
                                {$t('User')}
                            </label>
                            <div className={' tw-flex tw-flex-row tw-items-center tw-gap-x-1'}>
                                <select
                                    className={props.errors?.user ? 'tw-border tw-border-red-500 select-input' : 'tw-border-0 select-input'}
                                    id={'approver-user-' + uid}
                                    value={props.approver?.id || 0}
                                    onChange={changeApproverUser}
                                >
                                    <option value={0}>{$t('Select user')}</option>
                                    {usersList.map((user) => (
                                        <option key={generateKey()} value={user.id}>
                                            {user.first_name + ' ' + user.last_name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            {props.errors?.user && <div className="tw-text-red-500 tw-text-sm">{props.errors.user}</div>}
                        </div>
                    </div>
                    <div className="col-5">
                        <div className="tw-flex tw-flex-col tw-space-y-1.5">
                            <label htmlFor={'approver-value-' + uid} className="tw-text-charcoal tw-text-sm tw-mb-0">
                                {$t('Value')}
                            </label>
                            <div className={' tw-flex tw-flex-row tw-items-center tw-gap-x-1'}>
                                {isFinalApprover ? (
                                    <input className="form-control tw-bg-gray-200 tw-text-gray-500" value="N/A" disabled />
                                ) : (
                                    <input
                                        id={'approver-value-' + uid}
                                        type="number"
                                        className={`form-control ${props.errors?.value ? 'border border-danger' : ''}`}
                                        min={minValue}
                                        value={value}
                                        placeholder={$t('n/a')}
                                        disabled={props.type !== 'value'}
                                        onChange={changeValue}
                                        onBlur={onBlurValue}
                                    />
                                )}
                            </div>
                            {isFinalApprover && (
                                <div className="tw-text-red-500 tw-text-sm tw-mt-1">
                                    {$t(
                                        'Final approver must have no upper limits in this field, so because there are no further approvers in the system, no value can be added.',
                                    )}
                                </div>
                            )}
                            {props.errors?.value && <div className="tw-text-red-500 tw-text-sm">{props.errors.value}</div>}
                        </div>
                    </div>
                    <div className="col-2 d-flex justify-content-center align-items-end">
                        <Button variant="danger" className="tw-mx-1" onClick={props.removeApprover}>
                            {$t('Delete')}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
